import React from 'react';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';

const VerifyHome = () => {
    return (
        <div className="bloc l-bloc" id="bloc-0">
            <Container className="block-lg">
                <div className="row">
                    <div className="col">
                        <ul className="list-unstyled list-sp-md">

                            <li>======== QR코드 검증페이지 ======</li>
                            <li><Link to="verifications/coupon/config" className="a-btn a-block">0.기본환경설정</Link></li>
                            <li><Link to="verifications/coupon/code" className="a-btn a-block">1.QR자동생성 및 소명의 신뢰성</Link></li>
                            <li><Link to="verifications/coupon/issue" className="a-btn a-block">2.QR별 매장, 관광지 매칭의 정확도</Link></li>
                            <li><Link to="verifications/coupon/used" className="a-btn a-block">3.쿠폰 발행 및 사용처리</Link></li>
                            <li><Link to="verifications/coupon/list" className="a-btn a-block">4.QR쿠폰 데이터 가변성 처리</Link></li>

                        </ul>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default VerifyHome;
